import React, { useState, useRef } from 'react'
import Keyboard from 'react-simple-keyboard'
import 'react-simple-keyboard/build/css/index.css'
import styles from './index.module.scss'

const emailLayouts = {
    default: [
        '1 2 3 4 5 6 7 8 9 0',
        'q w e r t y u i o p',
        'a s d f g h j k l',
        '{shift} z x c v b n m @ . {backspace}',
        '- _ {space}'
    ],
    shift: [
        '! # $ % & * ( ) : ;',
        'Q W E R T Y U I O P',
        'A S D F G H J K L',
        '{shift} Z X C V B N M @ . {backspace}',
        '- _ {space}'
    ]
}

const ReceiptContact = ({ onConfirm, onCancel, error }) => {
    const [value, setValue] = useState('')
    const [layoutName, setLayoutName] = useState('default')
    const [cursorPos, setCursorPos] = useState(0)
    const [submitting, setSubmitting] = useState(false)
    const keyboardRef = useRef(null)

    const display = {
        '{backspace}': '⌫',
        '{space}': 'пробел',
        '{shift}': '⇧'
    }

    const buttonTheme = [
        { class: styles.hgFunction, buttons: '{shift} {backspace}' },
        { class: styles.hgSpace, buttons: '{space}' }
    ]

    const insertAtCursor = (char) => {
        const newVal = value.slice(0, cursorPos) + char + value.slice(cursorPos)
        setValue(newVal)
        const newPos = cursorPos + char.length
        setCursorPos(newPos)
        if (keyboardRef.current) keyboardRef.current.setInput(newVal)
    }

    const handleBackspace = () => {
        if (cursorPos === 0) return
        const newVal = value.slice(0, cursorPos - 1) + value.slice(cursorPos)
        setValue(newVal)
        setCursorPos(p => p - 1)
        if (keyboardRef.current) keyboardRef.current.setInput(newVal)
    }

    const handleKeyPress = (button) => {
        if (button === '{shift}') {
            setLayoutName(prev => prev === 'default' ? 'shift' : 'default')
        } else if (button === '{backspace}') {
            handleBackspace()
        } else if (button === '{space}') {
            insertAtCursor(' ')
        } else {
            insertAtCursor(button)
        }
    }

    const handleChange = () => {}

    const handleDisplayClick = (e) => {
        if (!value) return
        const el = e.currentTarget
        let charIndex = value.length

        const range = document.caretRangeFromPoint
            ? document.caretRangeFromPoint(e.clientX, e.clientY)
            : document.caretPositionFromPoint
                ? (() => { const p = document.caretPositionFromPoint(e.clientX, e.clientY); return p ? { startContainer: p.offsetNode, startOffset: p.offset } : null })()
                : null

        if (range && range.startContainer.nodeType === Node.TEXT_NODE) {
            const spanEl = range.startContainer.parentElement
            const spans = Array.from(el.querySelectorAll('span'))
            const idx = spans.indexOf(spanEl)
            if (idx === 0) charIndex = range.startOffset
            else if (idx === 2) charIndex = cursorPos + range.startOffset
        }

        setCursorPos(Math.min(charIndex, value.length))
    }

    const handleConfirm = async () => {
        if (!value.trim() || submitting) return
        setSubmitting(true)
        try {
            await onConfirm({ client_email: value.trim() })
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.title}>Введите email</div>
                <div className={styles.subtitle}>Укажите email для получения чека (54-ФЗ)</div>
                <div className={styles.inputRow}>
                    <div
                        className={styles.input}
                        onClick={handleDisplayClick}
                        onTouchEnd={handleDisplayClick}
                    >
                        <span>{value.slice(0, cursorPos)}</span>
                        <span className={styles.cursor} />
                        <span>{value.slice(cursorPos)}</span>
                        {!value && <span className={styles.placeholder}>example@mail.ru</span>}
                    </div>
                </div>
                {error && <div className={styles.error}>{error}</div>}
                <Keyboard
                    keyboardRef={r => (keyboardRef.current = r)}
                    layout={emailLayouts}
                    layoutName={layoutName}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                    display={display}
                    buttonTheme={buttonTheme}
                />
                <div className={styles.actions}>
                    <div className={styles.back} onClick={onCancel}>отменить</div>
                    <div
                        className={`${styles.confirm} ${(!value.trim() || submitting) ? styles.disabled : ''}`}
                        onClick={handleConfirm}
                    >
                        {submitting ? 'загрузка...' : 'OK'}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReceiptContact
